import React, { useEffect } from 'react';
import Modal from 'components/Modal';
import { gql } from '@apollo/client';
import { useMutation } from 'hooks/apollo';
import useFormatMessage from 'hooks/useFormatMessage';
import { Alert, Button, Form, Space } from 'antd';
import globalMessages from 'translations/messages';
import useGlobalContext from 'hooks/useGlobalContext';
import LanguageSelect from 'components/LanguageSelect';

const MUTATION = gql`
  mutation AddTranslations($id: ID!, $languages: [String!]!) {
    createSurveyTranslations(id: $id, languages: $languages)
  }
`;

const AddTranslations = ({ open, surveyId, exclude, onDone, onCancel }) => {
  const $t = useFormatMessage();
  const { message } = useGlobalContext();
  const [form] = Form.useForm();
  const [addTranslation, { loading: mutationLoading }] = useMutation(MUTATION);

  const onFinish = async (values) => {
    try {
      await addTranslation({
        variables: {
          id: surveyId,
          ...values,
        },
      });
      onDone();
    } catch (e) {
      message.error($t(globalMessages.errorFormFeedback));
    }
  };

  useEffect(() => {
    form.resetFields();
  }, [open]);

  return (
    <Modal
      title="Add translation"
      centered
      open={open}
      footer={(
        <Space>
          <Button onClick={onCancel}>
            Cancel
          </Button>
          <Button type="primary" onClick={form.submit} loading={mutationLoading}>
            Add
          </Button>
        </Space>
      )}
      onCancel={onCancel}
    >
      <Form requiredMark={false} form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item name="languages" rules={[{ required: true, message: 'Select at least one language' }]}>
          <LanguageSelect mode="multiple" exclude={exclude} />
        </Form.Item>
      </Form>
      <Alert message="We support English, Swedish, Danish, Norwegian, Finnish, French, German, Spanish and Italian languages in our survey, all other languages will display English messages. You can still create them and translate your questions but not all content will be translated." type="warning" showIcon />
    </Modal>
  );
};

export default AddTranslations;
